import styled from 'styled-components';

export const RenameOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
`;

export const TitleWrapper = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
	height: var(--navbar-height);
	cursor: text;
`;

export const RenameInput = styled.span`
	font-size: 14px;
	font-weight: 500;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	background: transparent;
	border: none;
	outline: none;
	padding: 0;
	margin: 0 0 0 6px;
	white-space: pre;
	max-width: 300px;
	overflow: hidden;
	min-width: 1ch;

	&::selection {
		background: ${({ theme }) => theme.blue[500]}33;
	}
`;

export const PublishButton = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const Share = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const Download = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const ReadOnlyBanner = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 5px 14px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	background: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.blue[500]};
	white-space: nowrap;
	line-height: 1.4;
`;

export const ReadOnlyLink = styled.button`
	all: unset;
	color: ${({ theme }) => theme.blue[600]};
	text-decoration: underline;
	text-underline-offset: 2px;
	transition: color 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.blue[800]};
	}
`;
